
import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useWorksheetPagination } from "./useWorksheetPagination";
import { useWorksheetFilters } from "./useWorksheetFilters";
import { useWorksheetAPI, Worksheet } from "./useWorksheetAPI";
import { worksheetSubjects } from "./subjects";
import { WorksheetFormValues } from "@/components/admin/worksheet/worksheetFormSchema";

export const useWorksheetManagement = (itemsPerPage = 10) => {
  const [totalCount, setTotalCount] = useState(0);
  const { currentPage, setCurrentPage, totalPages, getPaginationRange } = 
    useWorksheetPagination(totalCount, itemsPerPage);
  
  const { 
    searchQuery, setSearchQuery, 
    sortField, sortDirection, handleSort,
    subjectFilter, setSubjectFilter, 
  } = useWorksheetFilters(worksheetSubjects);
  
  const {
    fetchWorksheets,
    updateWorksheet,
    createWorksheet,
    deleteWorksheet
  } = useWorksheetAPI();

  // Fetch worksheets with pagination, sorting, and filtering
  const fetchWorksheetData = async () => {
    const { from, to } = getPaginationRange();
    const result = await fetchWorksheets(
      from, to, searchQuery, sortField, sortDirection, subjectFilter
    );
    setTotalCount(result.totalCount);
    return result.data;
  };

  const {
    data: worksheets = [],
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ["admin-worksheets", currentPage, itemsPerPage, searchQuery, sortField, sortDirection, subjectFilter],
    queryFn: fetchWorksheetData
  });

  // Reset page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, subjectFilter]);

  return {
    worksheets,
    isLoading,
    error,
    currentPage,
    setCurrentPage,
    totalPages,
    totalCount,
    searchQuery,
    setSearchQuery,
    sortField,
    sortDirection,
    handleSort,
    subjectFilter,
    setSubjectFilter,
    subjects: worksheetSubjects,
    updateWorksheet,
    createWorksheet,
    deleteWorksheet,
    refetch
  };
};
